/**
 * @generated SignedSource<<f03e663ee11b1d4b3193235c2c2f723a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HydrantGpmCountWidget_assetStatistics$data = {
  readonly gpmVeryGoodCount: number;
  readonly gpmGoodCount: number;
  readonly gpmAdequateCount: number;
  readonly gpmInadequateCount: number;
  readonly " $fragmentType": "HydrantGpmCountWidget_assetStatistics";
};
export type HydrantGpmCountWidget_assetStatistics = HydrantGpmCountWidget_assetStatistics$data;
export type HydrantGpmCountWidget_assetStatistics$key = {
  readonly " $data"?: HydrantGpmCountWidget_assetStatistics$data;
  readonly " $fragmentSpreads": FragmentRefs<"HydrantGpmCountWidget_assetStatistics">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HydrantGpmCountWidget_assetStatistics",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "gpmVeryGoodCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "gpmGoodCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "gpmAdequateCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "gpmInadequateCount",
      "storageKey": null
    }
  ],
  "type": "HydrantStatistics",
  "abstractKey": null
};

(node as any).hash = "309589adf1a840b4e0574407da0c882a";

export default node;
